import { provideLocal, toValue } from '@vueuse/core';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import { useFlagsProvide } from '~/modules/featureControl/composables/useFlagsProvide';
import { PRODUCT_DATA_REPOSITORY } from '../constants/providers';
import { useProductIdProvide } from './useProductIdProvide';
import { useInitUpc, UpcParser as upcParser } from '@nuxt-common/media-card-large/app/composables/useUpc';
import { useDataStore } from '@nuxt-common/media-card-large/app/composables/useVuexStore';
import { UPC } from '@nuxt-common/media-card-large/app/stores/types';

/**
 * * Product Data Provider
 * ! Dependency Injection of product data
 * Reduces complexity, removes prop drilling, increases performance
 * Plus, allows avoid unnecessary computed wraps
 */
export const useProductProvide = (productId: ProductId, productData: Product) => {
  useProductIdProvide(productId);

  provideLocal(PRODUCT_DATA_REPOSITORY, toValue(productData));

  useFlagsProvide();

  const { killswitches } = useKillswitches();
  const store = useDataStore(UPC);
  const existingData = store.get(productId) as Record<string, unknown> | undefined;

  const shouldPreventOverwrite = killswitches.isBopsUpcAvailabilityUpdateEnabled && existingData?.isBopsUpcAvailabilityUpdateEnabled;
  // Prevent overwriting the store with raw product data if it has already been updated with BOPS availability overrides
  if (!shouldPreventOverwrite) {
    useInitUpc({ id: productId, data: upcParser(productData) });
  }
};
